import { render, staticRenderFns } from "./light.vue?vue&type=template&id=7f0bd081"
import script from "./light.ts?vue&type=script&lang=js&external"
export * from "./light.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports